import styled from "styled-components";

const StyledTitle = styled.h1`
    font-family: Source Sans Pro;
    font-weight: 700;
    font-size: 56px;
    margin: 0 0 32px 0;
    color: #1e1e1e;
`;

const StyledBenefits = styled.h3`
    font-weight: 600;
    font-size: 24px;
    margin: 0;
    padding: 72px 0 32px 0;
    color: #000;
`;

const StyledWelcome = styled.h3`
    font-family: Source Sans Pro;
    font-weight: 600;
    font-size: 36px;
    margin: 0;
    padding: 16px 0 8px 0;
    color: #404040;
`;

const StyledComment = styled.p`
    font-family: Source Sans Pro;
    font-weight: 600;
    font-size: 20px;
    margin: 0 0 50px 0;
    color: #404040;
`;

const StyledText = styled.p`
    font-family: Source Sans Pro;
    font-weight: 400;
    font-size: 17px;
    margin: 0 0 0 14px;
    color: #1e1e1e;
`;

const StyledDiv = styled.div`
    display: flex;
    width: 455px;
    height: 58px;
    text-align: center;
    background-color: #f7e5ff;
    margin: 64px 0 0 0;
    border-radius: 16px;
    padding: 16px;
`;

const StyledGridDiv = styled.div`
    display: grid;
    max-width: 1080px;
    grid-template-columns: repeat(auto-fit, minmax(260px, auto));
    grid-auto-flow: row;
    gap: 8px;
`;

// HomeCard Components
const StyledCardDiv = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 260px;
    border: solid 1px #dee2e6;
    border-radius: 16px;
    padding: 24px;
`;

const StyledCardTitle = styled.h1`
    font-family: Source Sans Pro;
    font-weight: 700;
    font-size: 20px;
    margin: 0 12px;
    color: #212529;
`;

const StyledCardText = styled.p`
    font-family: Source Sans Pro;
    text-align: left;
    font-weight: 600;
    font-size: 17px;
    line-height: 20.4px;
    margin: 17px 0 0 0;
    color: #212529;
    opacity: 60%;
`;

export default {
    StyledTitle,
    StyledWelcome,
    StyledComment,
    StyledBenefits,
    StyledText,
    StyledDiv,
    StyledGridDiv,
    StyledCardDiv,
    StyledCardTitle,
    StyledCardText,
};
